module.exports = __webpack_public_path__ + "static/pump-20711c83834df037c41783a792b2f765.jpg";